module.exports = __webpack_public_path__ + "img/pic_start_coinsale1@2x.727b62c0.png";